import _forEach from 'lodash/forEach';
import _find from 'lodash/find';
import _isUndefined from 'lodash/isUndefined';
import _toInteger from 'lodash/toInteger';
import _merge from 'lodash/merge';
import _head from 'lodash/head';
import _toArray from 'lodash/toArray';

import URL from '@/tools/url';
import InstanceTree from '@/product-instance/instance-tree';
import InstanceOptions from '@/product-instance/instance-options';

/**
 * @class
 * @memberof ProductInstance
 * @alias variants
 *
 * @description
 * Класс для работы с вариантами товара
 *
 * @param {Object} config - Объект с конфигами
 */

var InstanceVariants = function(config) {
  var self = this;

  self.variants = config.variants;
  self.instanceId = config.instanceId;

  self.tree = new InstanceTree(config.tree);
  self.options = new InstanceOptions(config.options, config.settings, self.variants);

  self.urlVariant = URL.getKeyValue('variant_id');

  if (!self.options.isEmpty()) {
    self._setFirstSelection();
  }

  // TODO: тут вилка - установка по id из url или стандартная схема
  //console.log('Variants: constructor: self: ', self);

  return self;
};

/**
 * @description
 * Устанавливаем опцию внешним обработчиком
 * @param {Object} option - информация по устанавливаемой опции
 * @param {number} option.option_name_id || option.id - id опции
 * @param {number} option.position - позиция выбранного значения
 */
InstanceVariants.prototype.setOption = function(option) {
  var self = this;
  var _options = self.options.set(option);

  //console.debug('InstanceVariants: setOption: _options: start: ', _options);
  _options = self._mutateSelectedOptions(_options);
  //console.debug('InstanceVariants: setOption: _options: mutated: ', _options);

  self._update();

  return;
};

/**
 * Получить опцию
 */
InstanceVariants.prototype.getOption = function(index) {
  var self = this;
  var _option = self.options.get(index);

  return _option;
};

/**
 * @private
 * Проходим по выбранным опциям и фиксим неприавльно выбранные.
 * Неправильные - если при текущем варианте мы уходм в лес.
 */
InstanceVariants.prototype._mutateSelectedOptions = function(options) {
  var self = this;

  _forEach(options, function(_option, index) {
    var _selectedOptions = self.options.getSelected(index);
    var _isLeaf = self.tree.isLeaf(_selectedOptions);

    //console.log('Variants: _mutateSelectedOptions: _leaf: ', _isLeaf);
    // Если мы не можем найти такую ветку - вытаскиваем строение уровня
    // и помечаем первое свойство как выбранное
    if (!_isLeaf || (_isLeaf && !_isLeaf.available && !self.options.settings.selectUnavailable)) {
      var _first = self.options.getFirst(index, self.tree.getLevel(index, _selectedOptions));

      _option.selected = _first.position;
    }
  });

  return options;
};

/**
 * @method
 *
 * @description
 * Устанавливаем вариант по Id и переключаем опции
 */
InstanceVariants.prototype.setVariant = function(id, onInit) {
  var self = this;
  var _variant;

  self._setOptionByVariant(_toInteger(id));

  if (!onInit) {
    self._update();
  }

  return;
};

/**
 * @param {number} id - id варианта
 */
InstanceVariants.prototype.getVariant = function(id) {
  var self = this;
  var _selectedOptions = self.options.getSelected();
  var _branch;
  var _variant;

  //console.debug('InstanceVariants: getVariant: id', id);
  //console.debug('InstanceVariants: getVariant: _selectedOptions', _selectedOptions);
  if (!self.options.isEmpty()) {
    id = _toInteger(id);

    _branch = self.tree.getVariant(_selectedOptions);
    //console.debug('InstanceVariants: getVariant: _branch: ', _branch);

    id = id ? id : _branch.variant_id;
    //console.log('InstanceVariants: getVariant: id');

    _variant = _find(self.variants, { id: id });
  } else {
    _variant = _head(_toArray(self.variants));
  }
  //console.warn('InstanceVariants: getVariant: _variant: ', _variant);

  return _variant;
};

/**
 * @param {number} id - id варианта
 * TODO: выянить, где оно исполььзуется?
 */
InstanceVariants.prototype.getVariantById = function(id) {
  var self = this;

  return self.getVariant(id);
};

/**
 *
 */
InstanceVariants.prototype._update = function() {
  var self = this;

  EventBus.publish('product_instance:insales:system', { instanceId: self.instanceId });

  return ;
};

/**
 * @private
 */
InstanceVariants.prototype._setFirstSelection = function() {
  var self = this;

  //console.debug('InstanceVariants: _setFirstSelection: self.urlVariant: ', self.urlVariant);

  if (self._isValidVariant(self.urlVariant)) {
    self.setVariant(self.urlVariant, true);
  } else {
    self._initSelected();
  }

  return;
};

/**
 * @private
 */
InstanceVariants.prototype._isValidVariant = function(id) {
  var self = this;
  var _isValid = false;
  var _check;

  _check = _find(self.variants, { id: _toInteger(id) });
  //console.debug('InstanceVariants: _isValidVariant: _check: ', _check);

  if (!_isUndefined(_check)) {
    _isValid = true;
  }
  //console.debug('InstanceVariants: _isValidVariant: ', _isValid);

  return _isValid;
};

/**
 * Выставляем начальное состояние
 */
InstanceVariants.prototype._initSelected = function() {
  var self = this;
  var _options = self.options._getOptions();
  var _selectedOptions = [];

  _forEach(_options, function(_option, _index) {
    var _leaf = self.tree.getLevel(_index, _selectedOptions);
    var _first = self.options.getFirst(_index, _leaf);

    //console.debug('InstanceVariants: _initSelected: _leaf: ', _leaf);
    //console.debug('InstanceVariants: _initSelected: _first: ', _first);
    _selectedOptions.push(_first.position);

    self.options.set({
      option_id: _first.option_name_id,
      value_id: _first.id
    }, true);

    _leaf = _first.tree;
  });

  return;
};

/**
 * @private
 *
 * @description
 * Разбирает указанный вариант и выбирает указанные в нем
 * значения опций.
 *
 * @param {number} [variant_id] - id варианта, который надо установить
 */
InstanceVariants.prototype._setOptionByVariant = function(variant_id) {
  var self = this;
  var _variant = self.variants[variant_id];

  //console.debug('InstanceVariants: _setOptionByVariant: variant_id: ', variant_id);
  //console.debug('InstanceVariants: _setOptionByVariant: _variant: ', _variant);

  _forEach(_variant.option_values, function(value) {
    //console.debug('InstanceVariants: _setOptionByVariant: forEach: value: ', value);
    self.options.set({
      option_id: value.option_name_id,
      value_id: value.id
    });
  });
  //console.debug('InstanceVariants: _setOptionByVariant: result: ', self);

  return;
};

/**
 *
 */
InstanceVariants.prototype.setConfig = function(settings) {
  var self = this;

  self.settings = settings;
  self.options.setConfig(self.settings);
};

/**
 *
 */
InstanceVariants.prototype.getLevel = function(index) {
  var self = this;
  var _level;
  var _actualValues;

  _actualValues = self.tree.getLevel(index, self.options.getSelected());
  _level = self.options.get(index, _actualValues);
  //console.debug('InstanceVariants: getLevel: _level: ', _level);

  return _level;
};

/**
 *
 */
InstanceVariants.prototype.getStatus = function() {
  var self = this;
  var _status;

  _status = _merge({},
    self.options.getStatus()
  );

  return _status;
};

export default InstanceVariants;
